import { t } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/verlaufsdokumentation')({
  component: RouteComponent,

  loader: () => ({
    breadcrumb: {
      label: t`Verlaufsdokumentationen`,
      to: '/patienten/$id/verlaufsdokumentation',
      params: { id: 'patientId' },
    },
  }),
})

function RouteComponent() {
  return <Outlet />
}
